import { Injectable } from "@angular/core";
import { AngularFirestore } from "@angular/fire/compat/firestore";
import { AuthService } from "@core/auth.service";
import { encryptUsingAES256, UtilityService } from "@core/utility.service";
import { Browser } from "@capacitor/browser";
@Injectable({
  providedIn: "root",
})
export class LswTokenService {
  constructor(private angularFirestore: AngularFirestore, private authService: AuthService) {}

  openPepsoUrlView(pepsourl: any) {
    const encryptedToken = encryptUsingAES256(localStorage.getItem("fbToken"));
    let finalURL = "";
    if (pepsourl && pepsourl?.ownerId) {
      finalURL = pepsourl?.url + "&token=" + encryptedToken;
      Browser.open({ url: finalURL });
      return;
    } else if (pepsourl && pepsourl?.message) {
      finalURL = "https://web.lottosocial.com/messages/?token=" + encryptedToken;
      Browser.open({ url: finalURL });
      return;
    } else if (pepsourl?.peepso_group_url) {
      pepsourl["customToken"] = encryptedToken;
      Browser.open({ url: UtilityService.chatUrlFormation(pepsourl) });
      return;
    }
  }
}
